<template>
    <div class="uk-grid-medium uk-child-width-1-1" uk-grid>

        <!-- Content -->
        <div>
            <div class="uk-grid-medium" uk-grid>

                <!-- Items -->
                <div class="uk-width-1-1 uk-width-expand@m">

                    <div class="uk-child-width-1-1 uk-grid-medium" uk-grid>

                        <!-- Cards -->
                        <div>
                            <div class="uk-grid-medium uk-child-width-1-1 uk-child-width-1-3@s uk-child-width-1-4@m js-list-item-cards"
                                 uk-grid>
                                <shop-item-block v-for="Product in page.ShopItems.items"
                                        :shop-item="Product.ShopItem"
                                        :shop-item-prices="page.ShopItemPrices[Product.ShopItem.id]"
                                        :key="Product.ShopItem.id"
                                        :shop-order-item="page.ShopOrderItems[Product.ShopItem.id]"
                                        @buy-shop-item="buy">

                                </shop-item-block>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import ShopProductsMixin from "./ShopProductsMixin";
    import ShopItemBlock from "./ShopGroup/ShopItemBlock";

    export default {
        name: "SearchResult",
        components: {ShopItemBlock},
        mixins: [ShopProductsMixin],
        props: {

        },
        data() {
            return {
                page: {
                    ShopItems: this.ShopItems,
                    ShopItemPrices: this.ShopItemPrices,
                    ShopOrderItems: this.ShopOrderItems
                }
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// SearchResult.vue?7c3a4abc